export default "__VITE_ASSET__CpBGHmLL__"